export function onLoop(times, callback) {
    for (let i = 0; i < times; i++) {
        callback(i);
    }
}

export function debounce(callback, timeout) {
    let timer;
    return (...args) => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            callback(...args)
        }, timeout)
    }
}
export function getCssVariable(variable) {
    return getComputedStyle(document.documentElement).getPropertyValue(variable);
}

